/* ============================================
   Frankever Product Template — JS
   ============================================ */

function fkAddToCart(btn) {
  var checkBtn = document.querySelector(".fk-crosssell-check");
  var isChecked = checkBtn && checkBtn.classList.contains("checked");
  var idInput = document.querySelector('input[name="id"]');
  var qtyInput = document.querySelector('input[name="quantity"]');
  var mainId = idInput ? idInput.value : null;
  var qty = qtyInput ? parseInt(qtyInput.value) : 1;
  if (!mainId) return;

  var crosssellCard = document.querySelector(".fk-crosssell");
  var crosssellId = crosssellCard ? crosssellCard.dataset.crosssellVariantId : null;

  var items = [{ id: parseInt(mainId), quantity: qty }];
  if (isChecked && crosssellId) {
    items.push({ id: parseInt(crosssellId), quantity: 1 });
  }

  btn.disabled = true;
  btn.textContent = "Adding...";

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: items })
  })
  .then(function (res) { return res.json(); })
  .then(function () {
    window.location.href = "/cart";
  })
  .catch(function () {
    btn.disabled = false;
    btn.innerHTML = "Add to cart";
  });
}

(function () {
  "use strict";

  /* ---------- Image Gallery ---------- */
  function initGallery() {
    const thumbs = document.querySelectorAll(".fk-thumb");
    const mainImg = document.querySelector(".fk-main-product-img");
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
        mainImg.src = thumb.dataset.fullSrc || thumb.querySelector("img").src;
        mainImg.alt = thumb.querySelector("img").alt || "";
      });
    });
  }

  /* ---------- Pack Options ---------- */
  function initPacks() {
    var packs = document.querySelectorAll(".fk-pack");
    var dataEl = document.getElementById("fk-pack-data");
    var packData = [];
    if (dataEl) {
      try { packData = JSON.parse(dataEl.textContent); } catch(e) {}
    }

    packs.forEach(function (pack) {
      pack.addEventListener("click", function () {
        var idx = parseInt(pack.dataset.packIndex);
        var data = packData[idx];
        if (!data) return;

        packs.forEach(function (p) { p.classList.remove("active"); });
        pack.classList.add("active");

        // Update variant ID
        var idInput = document.querySelector('input[name="id"]');
        if (idInput) idInput.value = data.variantId;

        // Update price
        document.querySelectorAll(".fk-price").forEach(function(el) {
          if (data.compareAt) {
            var was = Math.round(parseFloat(String(data.compareAt).replace(/,/g, "")) * 100);
            var now = Math.round(parseFloat(String(data.price).replace(/,/g, "")) * 100);
            var off = (was > now) ? Math.floor((was - now) * 100 / was) : 0;
            el.innerHTML = '<span class="fk-price-old">$ ' + data.compareAt + '</span> $ ' + data.price +
              (off > 0 ? ' <span class="fk-price-off">-' + off + '%</span>' : '');
          } else {
            el.textContent = "$ " + data.price;
          }
        });

        // Update title
        document.querySelectorAll(".fk-title").forEach(function(el) {
          el.textContent = data.title;
        });

        // Update main image
        var mainImg = document.querySelector(".fk-main-product-img");
        if (mainImg && data.mainImage) mainImg.src = data.mainImage;

        // Update thumbnails
        var thumbContainer = document.querySelector(".fk-thumbnails");
        if (thumbContainer && data.images && data.images.length) {
          thumbContainer.innerHTML = "";
          data.images.forEach(function (img, i) {
            var btn = document.createElement("button");
            btn.className = "fk-thumb" + (i === 0 ? " active" : "");
            btn.dataset.fullSrc = img.full;
            var imgEl = document.createElement("img");
            imgEl.src = img.thumb;
            imgEl.alt = img.alt;
            imgEl.width = 154;
            imgEl.height = 154;
            imgEl.loading = "lazy";
            btn.appendChild(imgEl);
            btn.addEventListener("click", function () {
              thumbContainer.querySelectorAll(".fk-thumb").forEach(function (t) { t.classList.remove("active"); });
              btn.classList.add("active");
              if (mainImg) {
                mainImg.src = img.full;
                mainImg.alt = img.alt;
              }
            });
            thumbContainer.appendChild(btn);
          });
        }

        // Update stock status
        var stockEl = document.querySelector(".fk-stock");
        if (stockEl) {
          if (data.available) {
            stockEl.innerHTML = '<img src="' + stockEl.querySelector("img").src.replace("out.svg", ".svg") + '" alt="" width="20" height="20"><span class="fk-stock-text">In stock</span>';
          } else {
            stockEl.innerHTML = '<span class="fk-stock-text out">Out of stock</span>';
          }
        }
      });
    });
  }

  /* ---------- Quantity Selector ---------- */
  function initQuantity() {
    var wrap = document.querySelector(".fk-qty");
    if (!wrap) return;
    var minus = wrap.querySelector("[data-qty-minus]");
    var plus = wrap.querySelector("[data-qty-plus]");
    var display = wrap.querySelector(".fk-qty-value");
    var input = wrap.querySelector("input[name='quantity']");
    if (!minus || !plus || !display) return;

    minus.addEventListener("click", function () {
      var val = parseInt(display.textContent, 10);
      if (val > 1) {
        display.textContent = val - 1;
        if (input) input.value = val - 1;
      }
    });
    plus.addEventListener("click", function () {
      var val = parseInt(display.textContent, 10);
      display.textContent = val + 1;
      if (input) input.value = val + 1;
    });
  }

  /* ---------- Cross-sell Checkbox ---------- */
  function initCrossSell() {
    var checkBtn = document.querySelector(".fk-crosssell-check");
    if (!checkBtn) return;
    checkBtn.addEventListener("click", function () {
      checkBtn.classList.toggle("checked");
      var svg = checkBtn.querySelector("svg");
      if (svg) svg.style.display = checkBtn.classList.contains("checked") ? "block" : "none";
    });
  }

  /* ---------- Side Panel ---------- */
  function initSidePanel() {
    var panel = document.querySelector(".fk-panel");
    var overlay = document.querySelector(".fk-panel-overlay");
    var title = document.querySelector(".fk-panel-title");
    var btns = document.querySelectorAll(".fk-panel-link-btn");
    var closeBtn = document.querySelector(".fk-panel-close");
    var contents = document.querySelectorAll(".fk-panel-content");
    if (!panel || !overlay) return;

    function openPanel(panelId) {
      contents.forEach(function (c) { c.classList.remove("active"); });
      var target = document.querySelector('[data-panel-content="' + panelId + '"]');
      if (target) target.classList.add("active");
      var btn = document.querySelector('[data-panel="' + panelId + '"] span');
      if (title && btn) title.textContent = btn.textContent;
      panel.classList.add("open");
      overlay.classList.add("open");
      document.body.style.overflow = "hidden";
    }

    function closePanel() {
      panel.classList.remove("open");
      overlay.classList.remove("open");
      document.body.style.overflow = "";
    }

    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        openPanel(btn.dataset.panel);
      });
    });

    if (closeBtn) closeBtn.addEventListener("click", closePanel);
    overlay.addEventListener("click", closePanel);

    // Close on click outside the panel
    document.addEventListener("click", function (e) {
      if (!panel.classList.contains("open")) return;
      if (!panel.contains(e.target) && !e.target.closest(".fk-panel-link-btn")) {
        closePanel();
      }
    });

    // Close on Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("open")) {
        closePanel();
      }
    });
  }

  /* ---------- Sticky Tab Bar ---------- */
  function initTabBar() {
    var tabbar = document.querySelector(".fk-tabbar");
    if (!tabbar) return;

    window.addEventListener("scroll", function () {
      if (window.scrollY > 600) {
        tabbar.classList.add("visible");
      } else {
        tabbar.classList.remove("visible");
      }
    }, { passive: true });

    var tabs = tabbar.querySelectorAll(".fk-tab");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) { t.classList.remove("active"); });
        tab.classList.add("active");
        var target = document.getElementById(tab.dataset.target);
        if (target) target.scrollIntoView({ behavior: "smooth" });
      });
    });
  }

  /* ---------- Use Cases Carousel ---------- */
  function initUseCases() {
    var container = document.querySelector(".fk-usecases-scroll");
    var arrow = document.querySelector(".fk-usecases-arrow");
    var dots = document.querySelectorAll(".fk-dot");
    if (!container) return;

    if (arrow) {
      arrow.addEventListener("click", function () {
        container.scrollBy({ left: 624, behavior: "smooth" });
      });
    }

    function updateDots() {
      var children = Array.from(container.children);
      var scrollLeft = container.scrollLeft;
      var containerCenter = scrollLeft + container.offsetWidth / 2;
      var closestIndex = 0;
      var closestDist = Infinity;
      children.forEach(function (child, i) {
        var childCenter = child.offsetLeft + child.offsetWidth / 2;
        var dist = Math.abs(childCenter - containerCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle("active", i === closestIndex);
      });
    }

    container.addEventListener("scroll", updateDots, { passive: true });

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        var children = Array.from(container.children);
        var target = children[index];
        if (target) {
          container.scrollTo({
            left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
            behavior: "smooth",
          });
        }
      });
    });
  }

  /* ---------- Dimmer Control ---------- */
  function initDimmer() {
    var section = document.querySelector(".fk-dimmer-section");
    var touchzone = document.querySelector(".fk-dimmer-touchzone");
    var toggleBtn = document.querySelector(".fk-dimmer-toggle");
    var leds = document.querySelectorAll(".fk-dimmer-led");
    var bulbImg = document.querySelector(".fk-dimmer-bulb-wrap img");
    var glow = document.querySelector(".fk-dimmer-glow");
    var brightnessText = document.querySelector("[data-brightness-text]");
    if (!section || !touchzone) return;

    var brightness = 0;
    var isActivated = false;
    var isDragging = false;

    function update() {
      var intensity = brightness / 100;
      var activeLeds = Math.ceil(brightness / (100 / 7));
      var r = Math.round(46 + (245 - 46) * intensity);
      var g = Math.round(43 + (241 - 43) * intensity);
      var b = Math.round(40 + (233 - 40) * intensity);
      section.style.backgroundColor = "rgb(" + r + "," + g + "," + b + ")";
      section.style.color = intensity > 0.5 ? "#000" : "#fff";

      leds.forEach(function (led, i) {
        led.classList.toggle("active", i < activeLeds);
        led.classList.toggle("inactive", i >= activeLeds);
      });

      if (bulbImg) bulbImg.style.filter = "brightness(" + (1 + intensity * 0.3) + ")";
      if (glow) {
        glow.style.opacity = intensity;
        glow.style.transform = "translate(-50%, -50%) scale(" + (0.5 + intensity) + ")";
      }
      if (brightnessText) brightnessText.textContent = "Brightness: " + brightness + "%";
    }

    function calcBrightness(clientY) {
      var rect = touchzone.getBoundingClientRect();
      var relative = rect.bottom - clientY;
      var pct = Math.round((relative / rect.height) * 100);
      brightness = Math.min(100, Math.max(0, pct));
      if (!isActivated && brightness > 0) isActivated = true;
      update();
    }

    function fadeOut() {
      function step() {
        if (brightness <= 0) {
          brightness = 0;
          isActivated = false;
          update();
          return;
        }
        brightness = Math.max(0, brightness - 2);
        update();
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (toggleBtn) {
      toggleBtn.addEventListener("click", function () {
        if (isActivated) {
          fadeOut();
        } else {
          isActivated = true;
          brightness = 50;
          update();
        }
      });
    }

    touchzone.addEventListener("mousedown", function (e) {
      isDragging = true;
      calcBrightness(e.clientY);
    });
    window.addEventListener("mousemove", function (e) {
      if (isDragging) calcBrightness(e.clientY);
    });
    window.addEventListener("mouseup", function () {
      isDragging = false;
    });
    touchzone.addEventListener("touchstart", function (e) {
      isDragging = true;
      if (e.touches[0]) calcBrightness(e.touches[0].clientY);
    }, { passive: true });
    touchzone.addEventListener("touchmove", function (e) {
      if (isDragging && e.touches[0]) calcBrightness(e.touches[0].clientY);
    }, { passive: true });
    touchzone.addEventListener("touchend", function () {
      isDragging = false;
    });

    update();
  }

  /* ---------- RGB Toggle Switch ---------- */
  function initRgbInteractive() {
    var section = document.querySelector('.fk-rgb-section');
    var btn = document.querySelector('.fk-rgb-switch-btn');
    var text = document.querySelector('.fk-rgb-text');
    if (!section || !btn) return;

    btn.addEventListener('click', function () {
      var isOn = section.getAttribute('data-state') === 'on';
      section.setAttribute('data-state', isOn ? 'off' : 'on');
      if (text) {
        text.setAttribute('style', 'color: ' + (isOn ? '#EFF1F4' : '#BFC6D5') + ' !important');
      }
    });
  }

  /* ---------- Video Autoplay ---------- */
  function initVideo() {
    var video = document.querySelector('.fk-video');
    if (!video) return;

    var hasPlayed = false;
    var hasEnded = false;

    video.addEventListener('ended', function () {
      hasEnded = true;
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (!hasEnded) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
            hasPlayed = true;
          }
        } else {
          video.pause();
          if (hasPlayed) {
            video.currentTime = 0;
            hasEnded = false;
            hasPlayed = false;
          }
        }
      });
    }, { threshold: 0.3 });

    observer.observe(video);
  }

  /* ---------- Bought Together Carousel ---------- */
  function initBoughtTogether() {
    var track = document.querySelector('.fk-bought-track');
    var leftBtn = document.querySelector('.fk-bought-arrow--left');
    var rightBtn = document.querySelector('.fk-bought-arrow--right');
    if (!track || !leftBtn || !rightBtn) return;

    var scrollAmount = 284;

    leftBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    rightBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    track.style.overflowX = 'auto';
    track.style.scrollbarWidth = 'none';
    track.style.msOverflowStyle = 'none';
  }

  /* ---------- Interior Slides ---------- */
  function initInteriorSlides() {
    var track = document.querySelector('.fk-interior-track');
    var arrows = document.querySelectorAll('.fk-interior-arrow');
    var dots = document.querySelectorAll('.fk-interior-dot');
    if (!track) return;

    var current = 0;
    var total = 3;
    var isMobile = window.innerWidth <= 768;
    var slideWidth = isMobile ? window.innerWidth : 1281;
    var gap = isMobile ? 0 : 24;

    var slides = document.querySelectorAll('.fk-interior-slide');

    function updateArrows() {
      slides.forEach(function (slide, i) {
        var left = slide.querySelector('.fk-interior-arrow--left');
        var right = slide.querySelector('.fk-interior-arrow--right');
        if (left) left.style.display = (current === 0 && i === 0) ? 'none' : '';
        if (right) right.style.display = (current === total - 1 && i === total - 1) ? 'none' : '';
      });
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      current = index;
      if (isMobile) {
        track.scrollTo({ left: current * slideWidth, behavior: 'smooth' });
      } else {
        track.style.transform = 'translateX(-' + (current * (slideWidth + gap)) + 'px)';
      }
      updateArrows();
    }

    updateArrows();

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        if (arrow.dataset.dir === 'next') {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      });
    });

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function (e) {
        if (e.target.closest('.fk-interior-arrow') || e.target.closest('.fk-interior-slide-btn')) return;
        if (i !== current) {
          goTo(i);
        }
      });
    });

  }

  /* ---------- Interior Popups ---------- */
  function initInteriorPopups() {
    var overlay = document.querySelector('[data-interior-overlay]');
    var popups = document.querySelectorAll('.fk-interior-popup');
    var btns = document.querySelectorAll('[data-interior-popup]');
    if (!overlay || !popups.length) return;

    function closeAll() {
      popups.forEach(function (p) { p.classList.remove('open'); });
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-interior-popup');
        var target = document.querySelector('[data-interior-popup-panel="' + id + '"]');
        if (!target) return;
        if (target.classList.contains('open')) {
          closeAll();
          return;
        }
        closeAll();
        target.classList.add('open');
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });

    overlay.addEventListener('click', closeAll);

    document.addEventListener('click', function (e) {
      var openPopup = document.querySelector('.fk-interior-popup.open');
      if (!openPopup) return;
      if (!openPopup.contains(e.target) && !e.target.closest('[data-interior-popup]')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ---------- NE Dual Card Slides (mirrors Interior Slides) ---------- */
  function initNeDualCardSlides() {
    var track = document.querySelector('.ne-dual-card__track');
    if (!track) return;

    var slides = track.querySelectorAll('.ne-dual-card__slide');
    var arrows = document.querySelectorAll('.ne-dual-card__arrow');
    var total = slides.length;
    if (!total) return;

    var current = 0;
    var isMobile = window.innerWidth <= 768;
    var slideWidth = isMobile ? window.innerWidth : 1281;
    var gap = isMobile ? 0 : 24;

    function updateArrows() {
      slides.forEach(function (slide, i) {
        var left = slide.querySelector('.ne-dual-card__arrow--left');
        var right = slide.querySelector('.ne-dual-card__arrow--right');
        if (left) left.style.display = (current === 0 && i === 0) ? 'none' : '';
        if (right) right.style.display = (current === total - 1 && i === total - 1) ? 'none' : '';
      });
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      current = index;
      if (isMobile) {
        track.scrollTo({ left: current * slideWidth, behavior: 'smooth' });
      } else {
        track.style.transform = 'translateX(-' + (current * (slideWidth + gap)) + 'px)';
      }
      updateArrows();
    }

    updateArrows();

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        if (arrow.dataset.dir === 'next') {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      });
    });

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function (e) {
        if (e.target.closest('.ne-dual-card__arrow') || e.target.closest('.ne-dual-card__btn')) return;
        if (i !== current) {
          goTo(i);
        }
      });
    });
  }

  /* ---------- NE Dual Card Popups ---------- */
  function initNeDualCardPopups() {
    var overlay = document.querySelector('[data-ndc-overlay]');
    var popups = document.querySelectorAll('.ne-dual-card__popup');
    var btns = document.querySelectorAll('[data-ndc-popup]');
    if (!overlay || !popups.length) return;

    function closeAll() {
      popups.forEach(function (p) { p.classList.remove('open'); });
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-ndc-popup');
        var target = document.querySelector('[data-ndc-popup-panel="' + id + '"]');
        if (!target) return;
        if (target.classList.contains('open')) {
          closeAll();
          return;
        }
        closeAll();
        target.classList.add('open');
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('.ne-dual-card__popup-close').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeAll();
      });
    });

    overlay.addEventListener('click', closeAll);

    document.addEventListener('click', function (e) {
      var openPopup = document.querySelector('.ne-dual-card__popup.open');
      if (!openPopup) return;
      if (!openPopup.contains(e.target) && !e.target.closest('[data-ndc-popup]')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ---------- Scroll Reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".fk-reveal, .fk-reveal-left, .fk-reveal-scale");
    if (!els.length || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("revealed"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Init All ---------- */
  function initStickyGallery() {
    // CSS sticky is used, this fixes overflow on ancestors
    var el = document.querySelector('.fk-gallery');
    if (!el) return;
    el = el.parentElement;
    while (el) {
      var cs = getComputedStyle(el);
      if (cs.overflow !== 'visible' || cs.overflowY !== 'visible') {
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('overflow-y', 'visible', 'important');
        el.style.setProperty('overflow-x', 'clip', 'important');
      }
      el = el.parentElement;
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initStickyGallery();
    initGallery();
    initRgbInteractive();
    initPacks();
    initQuantity();
    initCrossSell();
    initSidePanel();
    initVideo();
    initBoughtTogether();
    initInteriorSlides();
    initTabBar();
    initUseCases();
    initDimmer();
    initInteriorPopups();
    initNeDualCardSlides();
    initNeDualCardPopups();
    initReveal();
  });

})();

/* Rename Reviews title with MutationObserver */
(function() {
  var isUpdating = false;
  function renameTitle() {
    if (isUpdating) return;
    isUpdating = true;
    var title = document.querySelector('#AirReviews-BlockWrapper .AirReviews-Blocks--Title');
    if (title && title.textContent.trim() !== 'Customers Reviews') {
      title.textContent = 'Customers Reviews';
    }
    var starRate = document.querySelector('#AirReviews-BlockWrapper .AirReviews-StarRate');
    if (starRate && !starRate.querySelector('.fk-custom-star')) {
      var img = document.createElement('img');
      img.src = '/cdn/shop/t/106/assets/Star-1.svg';
      img.alt = 'Star';
      img.className = 'fk-custom-star';
      starRate.appendChild(img);
    }
    var actions = document.querySelector(".AirReviews-Blocks--Actions");
    var listSort = document.querySelector(".AirReviews-Blocks__ListSort");
    if (actions && listSort && actions.previousElementSibling !== listSort) {
      listSort.after(actions);
    } else if (actions && !listSort) {
      var blocksList = document.querySelector('.AirReviews-Blocks__List');
      if (blocksList) blocksList.prepend(actions);
    }
    var listReview = document.querySelector(".AirReviews-Blocks__ListReview");
    if (listReview && !document.querySelector(".fk-top-reviews-heading")) {
      var h3 = document.createElement("h3");
      h3.className = "fk-top-reviews-heading";
      h3.textContent = "Top customer reviews";
      listReview.parentElement.insertBefore(h3, listReview);
    }
    var actionStars = document.querySelectorAll(".AirReviews-Blocks__ActionRate svg path");
    actionStars.forEach(function(p) {
      if (p.style.fill && p.style.fill !== "none" && p.style.fill !== "rgb(255, 255, 255)") {
        p.style.fill = "#FCB20D";
        p.parentElement.style.stroke = "#FCB20D";
      }
    });
    setTimeout(function() { isUpdating = false; }, 100);
  }

  var observer = new MutationObserver(function() {
    renameTitle();
  });

  function init() {
    var section = document.querySelector('#AirReviews-BlockWrapper');
    if (section) {
      observer.observe(section, { childList: true, subtree: true, characterData: true });
      renameTitle();
    } else {
      setTimeout(init, 500);
    }
  }
  init();
})();

/* Add reviews anchor */
(function() {
  function addReviewsAnchor() {
    var wrapper = document.querySelector('#AirReviews-BlockWrapper');
    if (wrapper) {
      var span = document.createElement('span');
      span.id = 'reviews';
      span.style.cssText = 'display:block;height:0;overflow:hidden;visibility:hidden';
      wrapper.prepend(span);
    } else {
      setTimeout(addReviewsAnchor, 1000);
    }
  }
  setTimeout(addReviewsAnchor, 1000);
})();

/* Info cards stagger fade-in on scroll into view */
(function() {
  var grids = document.querySelectorAll('.fk-info-cards__grid');
  if (!grids.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  grids.forEach(function(g) { observer.observe(g); });
})();
